<template>
  <div class="relative py-24 sm:py-32 min-h-fit">
    <UiContainer>
      <div
        class="max-w-3xl mx-auto text-center flex flex-col justify-center items-center"
      >
        <UiTitle
          animation="fadeIn"
          :code="t('home.whyUs.tag')"
          size="5xl"
        >
          {{ t('home.whyUs.title') }}
        </UiTitle>
        <UiParagraph
          class="mt-6"
          size="xl"
        >
          {{ t('home.whyUs.description') }}
        </UiParagraph>
        <div class="mt-10 flex items-center gap-x-6">
          <UiButton
            variant="primary"
            size="lg"
            @click="openForm()"
          >
            {{ t('pages.home.mainSection.button') }}
          </UiButton>
        </div>
      </div>
    </UiContainer>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import UiButton from '@/components/ui/UiButton.vue';

const { t } = useI18n();

// Methods
const openForm = () => {
  window.open(t('pages.home.mainSection.form-url'), '_blank');
};
</script>
